import styled from "styled-components";

export const AddTagsPageStyle = styled.div`
    h3 {
        color: #A0C63D;
        margin: 15px 0 0 0;
        font-weight: 600;
    }
`;
